<template>
  <div v-if="!isAllow">
    UnAuthorized Access
  </div>
  <div v-else>
    <el-row :gutter="20">
      <el-col :md="9">
        <h3>Default Benefits Form</h3>
        <el-form ref="form" :model="form" :key="key" label-width="120px" style="margin-top: 20px">
          <el-form-item label="Benefits" required>
            <el-select v-model="form.ben_id" filterable clearable placeholder="Please select benefits">
              <el-option
                v-for="item in benefits"
                :key="item.id"
                :label="item.name+ ' ( ' + item.desc + ' ) '"
                :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="Amount">
            <el-input v-model="form.amount" />
          </el-form-item>
          <el-form-item label="Status" required>
            <el-switch v-model="form.status"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveData">Create</el-button>
            <el-button @click="refresh">Refresh</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :md="15">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>List Of Default Benefits</span>
            <!--el-button style="float: right; padding: 3px 0" type="text">Operation button</el--->
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="effective_date"
              label="Benefits name">
              <template slot-scope="scope">
                {{ scope.row.name }} {{ '( ' + scope.row.desc + ' )' }}
              </template>
            </el-table-column>
            <el-table-column
              label="Amount">
              <template slot-scope="scope">
                {{ scope.row.amount ? Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="Status">
              <template slot-scope="scope">
                {{ scope.row.status === 1 ? 'Active' : 'In active' }}
              </template>
            </el-table-column>
            <el-table-column label="Operation" align="center">
              <template slot-scope="scope">
                <el-button type="warning" size="small" @click="edit(scope.row)"><i class="fas fa-edit"/></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EmpBenefits } from '../../../api/payroll/empbenefits'
import { NotifyError, NotifySuccess } from '../../../helper/Helper'
export default {
  name: 'DefaultBeneFits',
  data() {
    return {
      form: {
        'amount': 0,
        'ben_id': null,
        'status': false
      },
      loading: false,
      tableData: [],
      benefits: {},
      key: 0,
      isAllow: false
    }
  },
  created() {
    for (var i = 0; i < this.$store.getters.roles.length; i++) {
      var new_array = Object.entries(this.$store.getters.roles[i])
      for (var key = 0; key < new_array.length; key++) {
        if (new_array[key][1] === ('payroll_accounting')) {
          // console.log(new_array[key][1])
          this.isAllow = true
          this.getAll()
          this.getBenefits()
        }
      }
    }
  },
  methods: {
    getAll() {
      this.loading = true
      this.refresh()
      EmpBenefits({}, 'get', 'getDefaultBenefits').then(res => {
        // console.log(res.data)
        this.tableData = res.data
        this.loading = false
      }).catch()
    },
    getBenefits() {
      EmpBenefits({}, 'get', 'getBenefits').then(res => {
        this.benefits = res.data
      }).catch()
    },
    refresh() {
      this.form = {
        'amount': 0,
        'ben_id': null,
        'status': false
      }
    },
    saveData() {
      if (this.form.status === true) {
        this.form.status = 1
      } else {
        this.form.status = 0
      }
      EmpBenefits(this.form, 'post', 'saveDefaultBenefits').then(res => {
        if (res.data.status === 'error') {
          NotifyError(res.data.message)
        } else {
          NotifySuccess('Data Successfully Updated!')
        }
        this.getAll()
      }).catch()
    },
    edit(row) {
      this.key++
      // this.form = Object.assign({}, row)
      this.form.did = row.id
      this.form.amount = row.amount
      this.form.ben_id = row.ref_ben_id
      this.form.status = row.status === 1
    }
  }
}
</script>

<style scoped>

</style>
